<template>
  <div v-if="readyToRender">
    <filter-bar @add-new-lead="add_lead_state = true" :addition_state="lead_state" @cancel-add-new-lead="add_lead_state = false"></filter-bar>
    <add-lead v-if="add_lead_state" @close="add_lead_state = false"></add-lead>
    <results v-if="!add_lead_state">
    </results>
  </div>
</template>
<script>

import FilterBar from "components/CRM/FilterBar"
import Results from "components/CRM/Results"
import AddLead from "components/CRM/AddLead"
import {mapActions, mapGetters, mapState} from "vuex"

export default {
  name:"CRM",

  components:{
    FilterBar,
    Results,
    AddLead
  },

  data() {
    return {
        add_lead_state:false
    }
  },

  computed : {
    ...mapGetters("customers", ["selectAgenciesList"]),
    ...mapState(["user"]),
    readyToRender() {
      return this.selectAgenciesList.length && this.user != null
    },

    lead_state() {
      return this.add_lead_state
    }
  }
}
</script>
<style scoped>
.create-lead {
  margin-right: 20px;
  margin-top: 20px;
}
</style>



// WEBPACK FOOTER //
// client/views/CRM/Crm.vue